<div class="">
    <app-card-details/>
</div>

<div class="mt-4">
    <app-training-plan-hierarchy-summary/>
</div>


<form [formGroup]="filterForm" class="filters grid grid-cols-2 sm:grid-cols-2 md:grid-cols-5 gap-x-3">
    <mat-form-field appearance="outline">
        <mat-label>District</mat-label>
        <mat-select [value]="selectedDistrictId() || ''" (selectionChange)="selectedDistrictId.set($event.value); onDistrictChange()" formControlName="district">
            <!--mat-option value="">All Districts</mat-option-->
            <mat-option *ngFor="let district of districtList" [value]="district.id">
                {{ district.description }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Training Theme</mat-label>
        <mat-select [value]="selectedThemeId() || ''" (selectionChange)="onThemeChange($event.value)" formControlName="trainingTheme">
            <!--mat-option value="">All Themes</mat-option-->
            <mat-option *ngFor="let theme of trainingThemes" [value]="theme.id">
                {{ theme.description }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    @if(selectedThemeId()) {
    <mat-form-field appearance="outline">
        <mat-label>Training</mat-label>
        <mat-select [value]="selectedTrainingId() || ''" (selectionChange)="selectedTrainingId.set($event.value); onTrainingChange()" formControlName="training">
            <mat-option value="">All Trainings</mat-option>
            <mat-option *ngFor="let training of filteredTrainingList" [value]="training.id">
                {{ training.description }} - {{ training.code }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    }

    <mat-form-field appearance="outline">
        <mat-label>Session</mat-label>
        <mat-select [value]="selectedSessionId() || ''" (selectionChange)="selectedSessionId.set($event.value); onSessionChange()" formControlName="session">
            <!--mat-option value="">All Sessions</mat-option-->
            <mat-option *ngFor="let session of sessionList" [value]="session.id">
                {{ session.description }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <div class="h-auto mt-1">
        <button class="signin" (click)="onSearch()" type="button">
            <mat-icon>search</mat-icon>
            Search
        </button>
    </div>
</form>


<div class="grid grid-cols-2 lg:grid-cols-2 gap-[25px] mb-[25px]">
    <div class="">
        <div class="chart-details">
            <app-target-chart/>
        </div>
    </div>
    <div class="">
        <div class="chart-details">
            <app-training-wise-payment-chart [paymentData]="paymentData()"/>
            <p *ngIf="paymentError()" class="mt-2 text-sm text-red-600">{{ paymentError() }}</p>
        </div>

    </div>
</div>
<div class="grid grid-cols-2 lg:grid-cols-2 gap-[25px] mb-[25px]">
    <div class="">
        <div class="chart-details">
            <app-training-planchart [statusData]="trainingPlanStatusData()"/>
        </div>
    </div>
    <div class="">
        <div class="chart-details">
            <app-training-budget />
        </div>
    </div>
</div>


<!--back-to-top button-->
<app-back-to-top/>
